import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './auth.config';
import { AccountService } from './account';
import { HistoryEventService } from './history.event.service';
import { catchError, delay, map, Observable, of, Subject, switchMap, takeUntil } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthSourceGoogle } from '../const/AuthConst';

@Injectable({
  providedIn: 'root',
})
export class AuthGoogleService implements CanActivate {
  private oAuthService = inject(OAuthService);
  private accountService = inject(AccountService);
  private helper = new JwtHelperService();

  constructor(
    private router: Router,
    private historyEventService: HistoryEventService
  ) {
    this.initConfiguration();
  }

  initConfiguration() {
    this.oAuthService.configure(authConfig);
    this.oAuthService.setupAutomaticSilentRefresh();
    //При обновлении экрана на странице входа result=false, после вызова initImplicitFlow result=true
    this.oAuthService.loadDiscoveryDocumentAndTryLogin().then((result) => {
      if (this.oAuthService.hasValidIdToken()) {
        var isGoogle = this.accountService.isAuthSourceGoogle();
        var token = this.accountService.getAccessToken();
        if (token.length == 0 || !isGoogle) {
          this.accountService.getAccountTokenGoogle(this.oAuthService.getIdToken())
            .subscribe(
              {
                next: (data) => {
                  if (data.accountId != '-1') {
                    this.accountService.checkProfileAndSetInfo(data, AuthSourceGoogle);
                  }
                  else {
                    if (result) {
                      this.router.navigate(['noaccount']);
                    }
                  }
                },
                error: (e) => {
                  this.accountService.authSendError('', JSON.stringify(e), 'GoogleAuth');
                  this.router.navigate(['']);
                }
              }
            )
        }
      }
    }).catch((error) => {
      this.accountService.authSendError('', JSON.stringify(error), 'GoogleAuth');
    })
  }

  getToken() {
    return this.oAuthService.getIdToken();
  }

  login() {
    this.oAuthService.initImplicitFlow();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    var token = this.accountService.getAccessToken();
    var nonZeroLen = token.length != 0;
    if (nonZeroLen) {
      return of(true);
    }

    const stop = new Subject();

    var obj = of(1, 2, 3, 4, 5).pipe(
      delay(1000),
      map(() => {
        var token = this.accountService.getAccessToken();
        var nonZeroLen = token.length != 0;
        if (nonZeroLen) {
          stop.next(true);
        }
        return nonZeroLen;
      })
    );

    return obj;
  }

  logout() {
    this.oAuthService.revokeTokenAndLogout();
    this.oAuthService.logOut();
    localStorage.removeItem("token");
  }
}
